import { ALL_BLOCKS, AM_BLOCKS, PM_BLOCKS, BLOCK_LABELS, isFullDay } from "../lib/blocks";
import { BRAND } from "../lib/brand";

/* ───────────────────── TIME BLOCK PICKER ───────────────────── */
export function TimeBlockPicker({ dateKey, blocks, onChange, onClose }) {
  const dt = new Date(dateKey + "T12:00:00");
  const label = dt.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const currentBlocks = blocks || [];

  const toggleBlock = (b) => {
    const next = currentBlocks.includes(b)
      ? currentBlocks.filter((x) => x !== b)
      : [...currentBlocks, b].sort();
    onChange(dateKey, next);
  };

  const setPreset = (preset) => {
    onChange(dateKey, preset.length > 0 ? [...preset].sort() : []);
  };

  return (
    /* Every exit goes through onClose — the caller drops a day left with no
       blocks, so ✕, the backdrop and Done can't disagree about what happens. */
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-5 w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-gray-800">{label}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg">✕</button>
        </div>
        <p className="text-xs text-gray-500 mb-3">Tap blocks when player is <span className="font-semibold text-red-600">unavailable</span></p>

        <div className="grid grid-cols-4 gap-2 mb-4">
          {ALL_BLOCKS.map((b) => {
            const active = currentBlocks.includes(b);
            return (
              <button key={b} onClick={() => toggleBlock(b)}
                className={"py-2 px-1 rounded-lg text-xs font-semibold border-2 transition-all " +
                  (!active ? "bg-green-50 border-green-300 text-green-700" : "bg-red-500 border-red-500 text-white shadow-sm")}
              >
                {BLOCK_LABELS[b]}
              </button>
            );
          })}
        </div>

        <div className="flex gap-2 mb-4">
          <button onClick={() => setPreset([...ALL_BLOCKS])}
            className={"flex-1 py-1.5 text-xs font-medium rounded-lg border transition-colors " +
              (isFullDay(currentBlocks) ? "bg-red-100 border-red-300 text-red-700" : "border-gray-200 text-gray-600 hover:bg-red-50")}>
            Full Day
          </button>
          <button onClick={() => setPreset([...AM_BLOCKS])}
            className={"flex-1 py-1.5 text-xs font-medium rounded-lg border transition-colors " +
              (currentBlocks.length === AM_BLOCKS.length && AM_BLOCKS.every((b) => currentBlocks.includes(b))
                ? "bg-orange-100 border-orange-300 text-orange-700" : "border-gray-200 text-gray-600 hover:bg-orange-50")}>
            AM Only
          </button>
          <button onClick={() => setPreset([...PM_BLOCKS])}
            className={"flex-1 py-1.5 text-xs font-medium rounded-lg border transition-colors " +
              (currentBlocks.length === PM_BLOCKS.length && PM_BLOCKS.every((b) => currentBlocks.includes(b))
                ? "bg-orange-100 border-orange-300 text-orange-700" : "border-gray-200 text-gray-600 hover:bg-orange-50")}>
            PM Only
          </button>
        </div>

        <div className="flex gap-2">
          <button onClick={() => { onChange(dateKey, []); onClose(); }}
            className="flex-1 py-2 text-sm font-medium text-green-700 border border-green-200 rounded-xl hover:bg-green-50 transition-colors">
            Mark Available
          </button>
          <button onClick={onClose}
            className="flex-1 py-2 text-sm font-semibold text-white rounded-xl shadow-sm transition-colors"
            style={{ backgroundColor: BRAND.primary }}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
